import React from "react";
import WidgetWrapper from "components/WidgetWrapper";
import FlexBetween from "components/FlexBetween";
import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import AddBusinessOutlinedIcon from "@mui/icons-material/AddBusinessOutlined";
import LocationForm from "./components/LocationForm";
import { useLocationAdmin } from "./hooks/useLocationAdmin";
import LocationGrid from "./components/locationGrid";
import Header from "components/Header";

function LocationAdmin() {
  const {
    isLargeScreen,
    open,
    editMode,
    currentLocation,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
  } = useLocationAdmin();

  return (
    <Box m={isLargeScreen ? "1rem" : "1.5rem 0.5rem 2rem 0.5rem"}>
      <WidgetWrapper>
        <FlexBetween>
          <Header
            title="ALT Coach Location Admin"
            subtitle="Administer your school details"
          />
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: "5px",
              fontSize: "12px",
              padding: "5px 10px",
            }}
            onClick={handleOpen}
          >
            <AddBusinessOutlinedIcon sx={{ mr: "0.5rem" }} />
            Add new School
          </Button>
        </FlexBetween>
        <LocationGrid handleEditOpen={handleEditOpen} />

        {/* The Dialog component is a modal dialog that is displayed over the current page. */}

        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogTitle>
            {editMode
              ? `Edit School - ${currentLocation.name}`
              : "Add a New School"}
          </DialogTitle>
          <DialogContent>
            <LocationForm
              editMode={editMode}
              currentLocation={currentLocation}
              setOpen={setOpen}
              handleClose={handleClose}
            />
          </DialogContent>
        </Dialog>
      </WidgetWrapper>
    </Box>
  );
}

export default LocationAdmin;
